import styled from 'styled-components'

const DownloadButton = styled.div`
    display: flex;
    flex-wrap:wrap;
    align-items: center;
    background-color: #ffffff;
    color: #414670
    font-size: 16px;
    height: 71px;
    border-radius: 5.3px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.12);
    width: ${props => props.width || '227px'}
    cursor: pointer;
    transition: all 0.4s ease-in-out;
    &:focus {
        outline: none;
    }
    &:hover{
        text-decoration: none;
        box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.26);
    }
    &:visited{
        color: #414670;
    }
`

const DownloadParagraph = styled.p`
    font-size: 12px;
    margin: 0;
    text-align: left;
`

const RedirectText = styled.div`
    margin-top: 36px;
    display: flex;
    align-items: center;
    font-size: 16px;
    opacity: 0
    transition: opacity 0.3s ease;
`

const SubTitleStyle = {
    'fontFamily':' Lato',
    'fontSize':' 14px',
    'fontWeight':' normal',
    'fontStretch':' normal',
    'fontStyle':' normal',
    'lineHeight': '1.93',
    'letterSpacing':' normal'
}


export {
    DownloadButton,
    DownloadParagraph,
    RedirectText,
    SubTitleStyle,
}